import * as React from 'react';
import * as styles from './styles.css';

import Slider from 'react-slick';

import { RoundButton, IconChevronRight16, IconChevronLeft16 } from '@cian/ui-kit';

export const MyHomeWithSliderListing: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div data-testid="MyHomeWithSliderListing" className={styles['myhomewithsliderlisting-container']}>
      <Slider
        className="custom-slider"
        nextArrow={
          <div>
            <RoundButton title="" theme="fill_light" icon={<IconChevronRight16 />} />
          </div>
        }
        prevArrow={
          <div>
            <RoundButton title="" theme="fill_light" icon={<IconChevronLeft16 />} />
          </div>
        }
        autoplay={false}
        dots={false}
        infinite={false}
        slidesToShow={3}
        slidesToScroll={3}
      >
        {children}
      </Slider>
    </div>
  );
};

MyHomeWithSliderListing.displayName = 'MyHomeWithSliderListing';
